export default "__VITE_ASSET__fddc920d__"